import secondaryComponents from "../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import useReturns from "./useReturns";
import primaryComponents from "../../../../components/primaryComponents";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { returnOrderStatus } from "../../../../localdata";

const Returns = () => {
  const {
    storeList,
    isLoadingReturns,
    returns,
    metaDetails,
    isReturn,
    search,
    setIsReturn,
    gotoPage,
    filterByStoreId,
    filterByDate,
    filterBySearch,
    filterReturnStatus,
    startDate,
    endDate,
    // handleFetchReturns,
  } = useReturns();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Returns"
      description="View of all Returns"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${globalStyles.pageColumnGaps}`}
        >
          <div>
            <h4 className="mb-0">Returns</h4>
            <p>Record products returned by your customers.</p>
          </div>

          <div className={globalStyles.pageHeaders}>
            <p>{metaDetails?.total} Returns</p>

            <secondaryComponents.NavigateWithPermission
              permissionParentKey={"Inventory Management"}
              permissionChildKey="can_return_products"
            >
              <primaryComponents.Button
                classNames={"btn btn--primary ml-auto"}
                onClick={() => setIsReturn(true)}
              >
                + Return Product
              </primaryComponents.Button>
            </secondaryComponents.NavigateWithPermission>
          </div>

          {/* table section */}
          <div className={`${globalStyles.tableWrapper}`}>
            <div className={`${globalStyles.tableHeader}`}>
              <primaryComponents.SearchField
                classNames={`${globalStyles.searchField}`}
                placeholder="Search by order ID"
                trigger={(value) => filterBySearch(value)}
                value={search.get("query") || ""}
                triggerOnInput={true}
                showsearchBtn={true}
              />
              <div style={{ width: "140px" }}>
                <primaryComponents.SelectField
                  options={[
                    {
                      name: "All stores",
                      id: null,
                    },
                    ...storeList,
                  ]}
                  idKey="id"
                  nameKey="name"
                  onChange={(value) => {
                    filterByStoreId(value);
                  }}
                  value={
                    storeList?.find(
                      (store) => `${store?.id}` === search.get("store_id"),
                    )?.name || "All stores"
                  }
                  floatError={false}
                  isSearchable={false}
                />
              </div>

              <primaryComponents.DateRangeInput
                startDate={startDate}
                endDate={endDate}
                onChange={filterByDate}
              />

              <div style={{ width: "140px" }}>
                <primaryComponents.SelectField
                  value={
                    returnOrderStatus?.find(
                      (status) => status?.value === search.get("return_status"),
                    )?.label || "Select return status"
                  }
                  options={returnOrderStatus}
                  onChange={(value) => {
                    filterReturnStatus(value);
                  }}
                  nameKey="label"
                  idKey="value"
                  floatError={false}
                />
              </div>
            </div>

            {/* table section */}
            <secondaryComponents.LoaderHelper
              isLoading={isLoadingReturns}
              classNames="mt-5"
            >
              <secondaryComponents.ReturnsTable
                returns={returns}
                metaDetails={metaDetails}
                gotoPage={gotoPage}
              />
            </secondaryComponents.LoaderHelper>
          </div>

          {/* add return widget */}
          <secondaryComponents.Modal
            isActive={isReturn}
            closeModal={() => setIsReturn(false)}
            width={"800px"}
          >
            <secondaryComponents.ReturnStockWidget
              closeWidget={() => setIsReturn(false)}
            />
          </secondaryComponents.Modal>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
export default Returns;
